export default (videoWrapper: HTMLElement) => {
	if (!videoWrapper) return;

	const player: HTMLButtonElement | null =
		videoWrapper.querySelector(".btn--player");
	const close: HTMLButtonElement | null =
		videoWrapper.querySelector(".btn--close");
	const popup: HTMLElement | null = videoWrapper.querySelector(".popup");
	const iframe: HTMLIFrameElement | null =
		videoWrapper.querySelector("iframe");

	if (!player || !close || !popup || !iframe) return;

	const id: string | undefined = player.dataset.videoId;
	const url: string = `https://www.youtube.com/embed/${id}?rel=0&autoplay=1`;

	if (!id || !url) return;

	player.onclick = () => {
		iframe.src = `${url}`;
		popup.classList.add("open");
	};

	close.onclick = () => {
		iframe.src = "";
		popup.classList.remove("open");
	};
};
